import { Button, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ModalRename = ({ open, handelClose, handelOk, loading, form }) => {
    const { t } = useTranslation();
    return (
        <Modal
            centered
            width={500}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div>
                <div className="text-1xl text-center">
                    {t('policy.RenamePolicy')}
                </div>
                <Form form={form} layout="vertical" onFinish={handelOk}>
                    <Form.Item
                        className="my-10"
                        name="name"
                        label={t('policy.RenamePrivacyPolicy')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Input
                            size="large"
                            placeholder={t('policy.RenamePrivacyPolicy')}
                        />
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4">
                        <Button
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            loading={loading}
                            // onClick={handelOk}
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Submit')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};
export default ModalRename;
